<script>
import date from '../../../utils/date'

export default {
  name: 'TableRelatorios',
  props: ['dados'],
  data () {
    return {
      totalKM: 0
    }
  },
  created () {
    this.$on('printer', this.print)
  },
  methods: {
    diff (d1, d2) {
      return date.getDateDiff(d2.date, d1.date, 'minutes')
    },
    print () {
      let areaPrint = document.createElement('div')
      areaPrint.classList.add('removeAfterPrint')
      let printer = document.querySelector('#container-printer')
      printer = printer.cloneNode(true)
      printer.classList.add('removeAfterPrint')
      areaPrint.appendChild(printer)
      document.body.appendChild(areaPrint)
      let app = document.querySelector('#app')
      app.classList.add('hide')
      this.$nextTick(() => {
        window.print()
        setTimeout(() => {
          app.classList.remove('hide')
          let nodeToRemove = document.querySelector('.removeAfterPrint')
          document.body.removeChild(nodeToRemove)
        }, 300)
      })
    },
    calcKM (s) {
      let total = Number(s.kmFinal) - Number(s.kmInicial)
      // this.totalKM = this.totalKM + total
      return total
    }
  }
}
</script>

<template>
  <div class="tableRelatorios" id="container-printer">
    <div class="printer-page">'
      <div class="visible-print text-center m-t m-b"><h1 style="font-size: 16px">Atenção: O layout deste relatório será customizado de acordo às necessidades do Detran</h1></div>
      <table>
        <thead>
        <tr>
          <th>Solicitação</th>
          <th>Recolhimento</th>
          <th>Entrega</th>
          <th>Porte</th>
          <th>Trajeto percorrido</th>
          <th>Reboquista</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="s in dados">
          <td>{{ s.dataInicio.date|formatDate('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ s.dataInicioRecolhimento.date|formatDate('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ s.dataEntrega.date|formatDate('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ s.categoria ? s.categoria.nome : '' }}</td>
          <td>
            {{ calcKM(s) }}km em {{diff(s.dataInicio, s.dataEntrega)}}m
          </td>
          <td>{{ s.reboquista ? s.reboquista.nome : '' }}</td>
        </tr>
        </tbody>
      </table>
      <div class="wrapper text-center">
        <div>Total de veículos: <strong>{{Array.isArray(dados) && dados.length}}</strong></div>
        <!--<div>Total KM rodados: <strong>{{totalKM}}</strong></div>-->
      </div>

    </div>
    <div class="text-center hidden-print">
      <a class="btn" @click="print()">
        <i class="fa fa-print"></i> Imprimir
      </a>
    </div>
  </div>
</template>

<style lang="scss">
  .tableRelatorios {

    table {
      max-width: 800px;
      width: 100%;
      margin-bottom: 1rem;
      color: #212529;
      margin: 0 auto;
      border-collapse: collapse;
      user-select: none;

      thead {

        tr {
          background-color: #343a40;
          border-color: #454d55;

          th {
            color: #FFFFFF;
            vertical-align: bottom;
            font-weight: 700;
            font-size: 13px;
          }

        }
      }

      tbody {

        tr {
          background-color: #FFFFFF;
          border-top: 1px solid #dee2e6;

          td {
            vertical-align: top;
            color: #444444;
            font-weight: 600;
          }

        }
      }
    }

    td, th {
      padding: 15px 10px;
      text-align: left;
    }

  }
</style>



// WEBPACK FOOTER //
// TableRelatorios.vue?17f773f3